<template>
    <div>
        <card-header title="Tools" icon="fa-tools"/>

        <card-body>
            <card-list>
                <navigation-list-item
                    title="Mass E-Mail"
                    icon="fa-envelope"
                    @click="$openCard('mass-email', {}, card)"
                    :active="(child && child.definition.component === 'mass-email')"
                />
                <navigation-list-item
                    title="Reseller Contact Tool"
                    icon="fa-envelope"
                    @click="$openCard('reseller-contact', {}, card)"
                    :active="(child && child.definition.component === 'reseller-contact')"

                />

            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "../../components/common/CardHeader";
    import CardBody from "../../components/common/CardBody";
    import CardList from "../../components/common/CardList";
    import SubheaderListItem from "../../components/common/SubheaderListItem";
    import MenuListItem from "../../components/MenuListItem";
    import NavigationListItem from "../../TIER/components/NavigationListItem";

    export default {
        components: {
            NavigationListItem,
            CardHeader,
            CardBody,
            CardList,
            SubheaderListItem,
            MenuListItem
        },

        props: ['card', 'child'],
        methods: {

        },
        data() {
            return {

            };
        }
    };
</script>

<style lang="scss" scoped>

</style>
